<template>
  <div>
    <dialog-create-from-template
      v-if="show"
      ref="templateSelectDialog"
      :itemsIntegrated="itemsIntegrated"
      :itemsOthers="itemsOthers"
      :itemsOthersTile="itemsOthersTile"
      :networkListInTileFormat="networkListInTileFormat"
      :read-article-url="`https://docs.bemob.com/${locale}/add-traffic-source-from-templates`"
      :title="t('Traffic source templates')"
      @confirm="getItem"
      @close="close"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { pick } from 'lodash';
import DialogCreateFromTemplate from '@/components/dialogs/dialog-create-from-template.vue';
import NETWORK_LIST_IN_TILE_FORMAT from '@/views/reports/forms/traffic_sources/network-list-in-tile-format';
import {
  getTrafficSourceTemplatesApiRequest,
} from '@/services/api/traffic-sources-api';
import { useI18n } from '@/composables';
import { useStore } from '@/store';
import { $emitter } from '@/services/emitter';

type TrafficSourceTemplate = {
  id: string;
  name: string;
  main?: boolean;
  integrationType?: string;
  [key: string]: unknown;
};

const emit = defineEmits<{ close: [] }>();

const { t, locale } = useI18n();
const store = useStore();

const networkListInTileFormat = NETWORK_LIST_IN_TILE_FORMAT;
const show = ref(false);
const templates = ref<TrafficSourceTemplate[]>([]);

const itemPick = computed(() => {
  const keys = [
    'name',
    'postbackUrl',
    'extClickIdParam',
    'extClickIdPlaceholder',
    'costParam',
    'costPlaceholder',
    'postbackSendConfirmStatus',
    'main',
    'integrationType',
  ];
  for (let index = 1; index <= 10; index = index + 1) {
    keys.push('custom' + index + 'Param');
    keys.push('custom' + index + 'Placeholder');
    keys.push('custom' + index + 'Name');
  }
  return keys;
});

const itemsOthers = computed(() =>
  templates.value.filter(
    item => !item.main && !networkListInTileFormat[item.name],
  ),
);

const itemsIntegrated = computed(() =>
  templates.value.filter(item => item.main),
);

const itemsOthersTile = computed(() =>
  templates.value.filter(item => networkListInTileFormat[item.name]),
);

const getItem = async (id: string) => {
  const loadedTemplates = (await getTrafficSourceTemplatesApiRequest()) as TrafficSourceTemplate[];
  let item = loadedTemplates.find((template: TrafficSourceTemplate) => template.id === id);
  if (item) {
    item = {
      ...pick(item, itemPick.value),
      postbackSendConfirmStatus: true,
    };
  }

  close();
  $emitter.emit('open-dialog', { name: 'TrafficSourceDialog', data: { mode: 'create', item } });
};

const close = () => {
  emit('close');
};

onMounted(async () => {
  store.setLoading(true);
  try {
    templates.value = (await getTrafficSourceTemplatesApiRequest()) as TrafficSourceTemplate[];
    show.value = true;
  } finally {
    store.setLoading(false);
  }
});
</script>
